import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Tooltip, message } from 'antd';
import { useLocation } from 'react-router';
import SuperButton from './SuperButton';
import { visitor } from '@/utils/store/visitor';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import { reportPV } from '@/services/api';

/**
 * 侧边栏底部组件，包含用户信息和登录状态
 */
const SidebarFoot: React.FC = () => {
    // 只使用 Supabase 认证状态
    const supabaseAuth = useSnapshot(supabaseAuthStore);
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const isDebug = query.get("isDebug");

    // 不会出现登录时，isLoading为false，isAuthenticated没有加载，同时根据user===undefined二次保险
    const isNotLogin = !supabaseAuth.isLoading && !supabaseAuth.isAuthenticated && supabaseAuth.user === undefined;

    // 允许访问评测页面，即使未登录
    const allowedPaths = [
        "/", "/evaluation", "/agreement"
    ];
    const isAllowedPath = allowedPaths.some(path =>
        location.pathname === path
        || location.pathname.startsWith(path + "/")
    );

    if (!isAllowedPath && isNotLogin) {
        window.location.href = "/";
    }

    // useEffect(() => {
    //   if (isAuthenticated) {
    //     runFetchVIP(user?.sub);
    //   }
    // }, [isAuthenticated, user?.sub, runFetchVIP]);

    // useEffect(() => {
    //   // VIP数据变化时的处理逻辑
    // }, [vipdata]);


    // 上报PV信息
    useEffect(() => {
        visitor.getFingerprint().then(() => {
            if(supabaseAuth.isLoading){
                return;
            }
            
            const vid = visitor.visitorId;
            const isGuest = !supabaseAuth.isAuthenticated;
            reportPV(
                {
                    userId: supabaseAuth.id || undefined,
                    guestId: vid,
                    isGuest
            }
            );
        });
    }, [supabaseAuth.isLoading, supabaseAuth]);

    return (
        <div className="flex-none p-4 pb-0 pt-15 mt-auto">
            <div className="flex justify-end items-center gap-2">
                {isDebug && isDebug === "true" && (
                    <button
                        onClick={() => {
                            console.log("debug Info: ", supabaseAuth.user);
                        }}
                    >
                        debug
                    </button>
                )}

                {!supabaseAuth.isAuthenticated && (
                    <Tooltip title="当前为游客用户，试用次数不足时需要登录后继续使用">
                        <InfoCircleOutlined style={{ fontSize: "18px" }} className="" />
                    </Tooltip>
                )}

                {supabaseAuth.isAuthenticated &&
                          <SuperButton/>
                    }

                {supabaseAuth.isAuthenticated && (
                    <button
                        className="shadow-none border-0 rounded-full btn btn-xs w-17   text-white bg-[#99B9FF]"
                        onClick={() => {
                            window.open("/user/detail");
                        }}
                    >
                        <UserOutlined style={{ fontSize: "18px" }} className="pr-1" />
                        我的
                    </button>
                )}

                <button
                    className={`shadow-none border-0 rounded-full btn btn-xs w-12   text-white bg-[#99B9FF] ${!supabaseAuth.isAuthenticated ? "w-20" : ""}`}
                    onClick={() => {
                        if (supabaseAuth.isLoading) {
                            message.info("正在加载");
                            return;
                        }

                        if (supabaseAuth.isAuthenticated) {
                            // 使用 Supabase 登出方法
                            window.location.href = '/s_auth/logout';
                        } else {
                            window.location.href = '/s_auth/login';
                        }
                    }}
                >
                    {supabaseAuth.isLoading ? (
                        <div className="loading loading-spinner"></div>
                    ) : (
                        supabaseAuth.isAuthenticated ? "登出" : "登录/ 注册"
                    )}
                </button>
            </div>
             {/* 底部信息区域 */}
            <div className=" text-[8px] opacity-60 pt-2">
                <div className="flex justify-center gap-2  text-gray-500 py-2">
                    <div className="link link-hover cursor-pointer" onClick={() => {window.open("/agreement/user")}}>用户协议</div>
                    <div className="link link-hover cursor-pointer" onClick={() => {window.open("/agreement/privacy")}}>隐私协议</div>
                    <a href="https://beian.miit.gov.cn/" target="_blank" className="link link-hover">ICP-粤ICP备2025403006号-1</a>
                </div>
            </div>
        </div>
    );
};

export default SidebarFoot;